module.exports = __webpack_public_path__ + "static/media/mes-2.5caa5fde.jpg";